import { defineMessages } from 'react-intl';

export default defineMessages({
  shopperBulletCompareServices: {
    description: 'Text displayed to the user to describe the first bullet point of the shopper',
    defaultMessage: '1. Compare these services',
    id: 'h3v08a',
  },
  shopperBulletDeliveryRestriction: {
    description: 'Text displayed to the user to describe the second bullet point which is around the delivery time',
    defaultMessage: '2. Restrict to services that estimate delivery within',
    id: '9jhs2W',
  },
  shopperBulletSelectLowestRate: {
    description: 'Text displayed to the user to describe the third bullet point which is around an override of the above bullets',
    defaultMessage: '{stepNumber}. Select the lowest rate',
    id: 'Fb7nej',
  },
  shopperBulletServiceOverride: {
    description: 'Text displayed to the user to describe the third bullet point which is around an override of the above bullets',
    defaultMessage: '{stepNumber}. Service Preference',
    id: '2McShf',
  },
  shopperBulletOtherwiseSelectLowestRate: {
    description: 'Text displayed to the user to describe the third bullet point which is around an override of the above bullets',
    defaultMessage: '{stepNumber}. Otherwise select the lowest rate',
    id: '0zo2Oh',
  },
});
